const {
    fetchProducts,
    getPredictions,
    getPlaceDetails,
    updateCart,
    checkout,
    resetPersonalizationForm,
    sortRetailersByEngravedAndPrice,
    formattedPrice,
    calculateCartTotal
} = require("./liquidSDKHelpers");
const $html = $("html");
const $body = $html.find("body");
const $skeletonLoader = $body.find(".skeleton-loader");
const $liquidHeaderMiniCart = $body.find(".liquid-header-mini-cart");
const $liquidCustomMiniCart = $body.find(".liquid-custom-mini-cart");
const $cartItems = $liquidCustomMiniCart.find(".cart-items");
const $checkoutCTA = $liquidCustomMiniCart.find(".checkout-button");
const $subtotalPrice = $liquidCustomMiniCart.find(".subtotal-value .price");
const $emptyCartText = $liquidCustomMiniCart.find(".empty-cart-text");
const $customLiquid = $body.find(".custom-liquid");
const $addressAvailabilityBlock = $customLiquid.find(".address-availability-block");
const $sizeContainerWrapper = $customLiquid.find(".size-container-wrapper");
const $addressBlock = $customLiquid.find(".address-block");
const $addToCartBlock = $customLiquid.find(".add-to-cart-block");
const $personalizationBlock = $customLiquid.find(".personalization-block");
const $suggestionsContainer = $customLiquid.find(".suggestions-container");
const $suggestionsList = $customLiquid.find(".suggestions-list");
const $address1Container = $customLiquid.find(".address-1-container");
const $attributesContainer = $customLiquid.find(".attributes-container");
const $address1Input = $address1Container.find(".address-1-input");
const $addressLoading = $address1Container.find(".liquid-loading");
const $addressSave = $customLiquid.find(".address-save");
const $saveLoading = $addressSave.find(".liquid-loading");

/**
* Handles the click event outside the suggestions dropdown and hides the suggestions.
* This function is typically used to close the suggestions dropdown when the user clicks outside of it.
*/
function handleClickOutsideSuggestions() {
    toggleSuggestionsVisibility(false);
}

/**
* Handles the click event outside the mini cart to hide it.
* This function toggles the visibility of the mini cart to false.
*/
function handleCloseMiniCart() {
    toggleMiniCartVisibility(false);
}

/**
* Handles the action of opening the mini cart by setting its visibility to true.
* This function is typically triggered by user interaction, such as clicking a button.
*/
function handleOpenMiniCart() {
    toggleMiniCartVisibility(true);
}

/**
* Toggles the visibility of the address block and the enter address button.
*
* @param {boolean} show - Determines whether to show or hide the address block.
*/
function toggleAddressBlockVisibility(show) {
    $addressBlock.toggleClass("d-none", !show);
}

/**
* Toggles the visibility of the skeleton loader element.
*
* @param {boolean} show - Determines whether to show or hide the skeleton loader.
*/
function toggleSkeletonLoaderVisibility(show) {
    $skeletonLoader.toggleClass("d-none", !show);
}

/**
* Toggles the visibility of the address availability block.
* Adds or removes the "d-none" class based on the `show` parameter.
*
* @param {boolean} show - Determines whether to show or hide the address availability block.
*/
function toggleAvailabilityBlockVisibility(show) {
    $addressAvailabilityBlock.toggleClass("d-none", !show);
}

/**
* Toggles the visibility of the checkout call-to-action (CTA) button.
*
* @param {boolean} show - A flag indicating whether to show or hide the checkout CTA.
*/
function toggleCheckoutCTAVisibility(show) {
    $checkoutCTA.toggleClass("d-none", !show);
}

/**
* Toggles the visibility of the suggestions container.
*
* @param {boolean} show - A flag indicating whether to show or hide the suggestions container.
*/
function toggleSuggestionsVisibility(show) {
    $suggestionsContainer.toggleClass("d-none", !show);
}

/**
* Toggles the visibility of the attributes container by adding or removing the "d-none" class.
*
* @param {boolean} show - A flag indicating whether to show or hide the attributes container.
*/
function toggleAttributesContainerVisibility(show) {
    $attributesContainer.toggleClass("d-none", !show);
}

/**
* Toggles the visibility of the mini cart and controls the page scroll behavior.
*
* @param {boolean} show - A flag indicating whether to show or hide the mini cart.
*/
function toggleMiniCartVisibility(show) {
    $liquidCustomMiniCart.toggleClass("active", show);
    $html.toggleClass("js-no-scroll", show);
}

/**
* Displays the liquid error block by hiding the custom liquid element and showing the error message.
* This function adds the "d-none" class to the $customLiquid element to hide it,
* and removes the "d-none" class from its child element with the class "custom-liquid-error" to display the error message.
*/
function toggleLiquidErrorBlockVisibility(show) {
    const $customLiquidErrorWrapper = $(".custom-liquid-error-wrapper");

    if (show) {
        sessionStorage.removeItem("liquid_load_retry");
        sessionStorage.removeItem("liquid_address");
        sessionStorage.removeItem("liquid_products");
    }

    toggleAddressBlockVisibility(show);
    toggleAttributesContainerVisibility(!show);
    $customLiquidErrorWrapper.toggleClass("d-none", !show);
}

/**
* Handles the edit address action by toggling the visibility of the address block and attributes container.
* This function makes the address block visible and hides the attributes container.
*/
function handleEditAddress() {
    toggleAddressBlockVisibility(true);
    toggleAttributesContainerVisibility(false);
}

/**
* Handles the display of the address block by toggling its visibility.
* This function hides the availability block and shows the address block.
*/
function handleDisplayAddress() {
    toggleAvailabilityBlockVisibility(false);
    toggleAddressBlockVisibility(true);
}

/**
* Updates the variant data for a given product ID by fetching the relevant product information
* from session storage, sorting retailers by engraving and price, and updating the UI elements
* with the lowest price retailer's details.
*
* @param {number} productId - The ID of the product variant to update.
* @returns {void}
*/
function updateVariantData(productId) {
    const products = JSON.parse(sessionStorage.getItem("liquid_products"));
    const variant = products[0].variants.find(variant => variant.productId === parseInt(productId, 10));
    const sortedRetailers = sortRetailersByEngravedAndPrice(variant);
    const retailerWithLowestPrice = sortedRetailers[0];
    const $price = $attributesContainer.find(".price");
    const $shopAddress = $attributesContainer.find(".shop-address");
    const $deliveryTime = $attributesContainer.find(".delivery-time");
    const currency = $price.attr("data-currency");
    const $quantityInput = $attributesContainer.find(".quantity-input");

    // isPersonalisable if false it will always hide the personalization block and always show the add-to-cart block
    // regardless of the retailer's engraving configuration and the personalization capability of the product.
    if (variant.engravingConfigs && variant.engravingConfigs.active && $customLiquid.data("isPersonalisable")) {
        $addToCartBlock.addClass("d-none");
        $personalizationBlock.removeClass("d-none");
    } else {
        $addToCartBlock.removeClass("d-none");
        $personalizationBlock.addClass("d-none");
    }

    $quantityInput.attr("value", 1);
    $sizeContainerWrapper.find(".active").attr("data-variant-id", retailerWithLowestPrice.variantId);
    $price.text(`${currency}${formattedPrice(retailerWithLowestPrice.price)}`);
    $shopAddress.text(retailerWithLowestPrice.retailer.name);
    $deliveryTime.text(retailerWithLowestPrice.shippingMethod.shortDeliveryExpectation);
}

/**
* Handles the selection of a size variant for a product.
*
* This function is triggered when a size option is clicked. It updates the UI to reflect the selected size
* and updates the variant data accordingly.
*
* @function
* @returns {void}
*/
function handlePickSize() {
    const $this = $(this);

    if ($this.hasClass("active")) {
        return;
    }

    const $container = $this.parent();
    const productId = $this.attr("data-product-id");

    $.each($container.find(".size-container"), function(index, sizeContainer) {
        const $sizeContainer = $(sizeContainer);

        if ($sizeContainer.attr("data-product-id") === productId) {
            $sizeContainer.addClass("active");
        } else {
            $sizeContainer.removeClass("active");
        }
    });

    executeWithTryCatch(updateVariantData, productId);
}

/**
* Executes a function with provided parameters within a try-catch block.
* If an error occurs, it handles the error by checking a session storage flag and either
* showing an error block or retrying the function execution after reloading the page.
*
* @param {Function} fn - The function to be executed.
* @param {Object} params - The parameters to be passed to the function.
*/
function executeWithTryCatch(fn, params) {
    try {
        fn(params);
    } catch (error) {
        const loadRetry = sessionStorage.getItem("liquid_load_retry");

        if (loadRetry) {
            toggleLiquidErrorBlockVisibility(true);
        } else {
            sessionStorage.setItem("liquid_load_retry", true);
            sessionStorage.removeItem("liquid_address");
            sessionStorage.removeItem("liquid_products");
            location.reload();
        }
    }
}

/**
* Renders product data based on the provided address and updates the UI accordingly.
* Fetches product data, updates session storage, and dynamically creates size buttons for product variants.
* Sets up event listeners for size selection and quantity adjustment.
*
* @async
* @function renderProductData
* @param {string} address - The address used to fetch product data.
* @returns {Promise<void>} - A promise that resolves when the product data has been rendered and the UI updated.
*/
async function renderProductData(address) {
    const products = await fetchProducts(address);

    if (!products.length || !products[0].variants.length) {
        toggleSkeletonLoaderVisibility(false);
        toggleLiquidErrorBlockVisibility(true);
        $saveLoading.addClass("d-none");
        $addressSave.removeClass("disabled");
        return;
    } else {
        toggleLiquidErrorBlockVisibility(false);
    }

    const $fullAddress = $customLiquid.find(".full-address");

    sessionStorage.setItem("liquid_products", JSON.stringify(products));

    $sizeContainerWrapper.find(".size-container").remove();

    $.each(products[0].variants, function(index, variant) {
        const isFirst = index === 0;
        const size = variant.size.split(",");

        if (size.length > 1) {
            const $sizeButton = $(`
                <button class="size-container ${isFirst ? "active" : ""}" data-product-id="${variant.productId}">
                    <span class="size-title">${size[0]}</span>
                    <span class="size-type">${size[1]}</span>
                </button>`);

            $sizeButton.on("click", handlePickSize);
            $sizeContainerWrapper.append($sizeButton);

            if (isFirst) {
                updateVariantData(variant.productId);
            }
        }
    });

    $fullAddress.text(address);
    toggleSkeletonLoaderVisibility(false);
    toggleAttributesContainerVisibility(true);
    toggleAddressBlockVisibility(false);
    $saveLoading.addClass("d-none");
    $addressSave.removeClass("disabled");
}

/**
* Handles the increase of the quantity input field when the associated button is clicked.
* Increments the current value of the quantity input by 1.
*/
function handleQuantityIncrease() {
    const $this = $(this);
    const $quantityInput = $this.siblings(".quantity-input");
    const value = parseInt($quantityInput.attr("value"), 10);

    $quantityInput.attr("value", value + 1);
}

/**
* Handles the decrease of the quantity input value, ensuring it does not go below the minimum value.
*
* This function is typically bound to a decrease button click event. It retrieves the current value
* of the quantity input field, checks the minimum allowable value, and decreases the quantity by one
* if it is above the minimum.
*
* @function
* @returns {void}
*/
function handleQuantityDecrease() {
    const $this = $(this);
    const $quantityInput = $this.siblings(".quantity-input");
    const value = parseInt($quantityInput.attr("value"), 10);
    const min = parseInt($this.attr("data-min"), 10);

    if (value > min) {
        $quantityInput.attr("value", value - 1);
    }
}

/**
* Handles the save address action by formatting the address and updating the UI accordingly.
* If a formatted address is present, it shows a loading indicator, disables the save button,
* and renders the product data based on the formatted address.
*
* @async
* @returns {void}
*/
async function handleSaveAddress() {
    const formattedAddress = $address1Input.attr("data-formatted-address");

    if (formattedAddress) {
        const addressJSON = sessionStorage.getItem("liquid_address");
        const address2Input = $customLiquid.find(".address-2-input");
        const address2 = address2Input.val().trim();

        if (addressJSON) {
            let address = JSON.parse(addressJSON);

            if (address && address2) {
                address.address2 = address2;
                sessionStorage.setItem("liquid_address", JSON.stringify(address));
            }
        }

        $saveLoading.removeClass("d-none");
        $addressSave.addClass("disabled");
        renderProductData(formattedAddress);
    }
}

/**
* Toggles the visibility of suggestion items within the suggestions container.
* Items with the specified class will be shown, while others will be hidden.
*
* @param {string} exceptClass - The class name of the suggestion items to be shown.
*/
function suggestionsToggleVisibility(exceptClass) {
    $suggestionsContainer.find(".suggestion-item").each(function() {
        const $this = $(this);

        if ($this.hasClass(exceptClass)) {
            $this.removeClass("d-none");
        } else {
            $this.addClass("d-none");
        }
    });

    toggleSuggestionsVisibility(true);
}

/**
* Handles the selection of an address from a list, updates the address input field,
* and fetches additional place details to populate the form.
*
* @async
* @function handleSelectAddress
* @returns {void}
*/
async function handleSelectAddress() {
    const $this = $(this);
    const description = $this.text().trim();
    const placeId = $this.attr("data-place-id");

    $address1Input.val(description);

    const placeDetails = await getPlaceDetails(placeId);

    if (placeDetails && placeDetails.address1 && placeDetails.city && placeDetails.state && placeDetails.zipCode) {
        sessionStorage.setItem("liquid_address", JSON.stringify(placeDetails));
        $address1Input.attr("data-formatted-address", placeDetails.formattedAddress);
        $addressSave.removeClass("disabled");
    } else {
        $addressBlock.addClass("address-error");
        $saveLoading.addClass("d-none");
    }
}

/**
* Renders suggestion items in the suggestions list.
*
* This function removes any existing suggestion options from the suggestions list,
* then iterates over the provided suggestions array to create and append new suggestion
* items to the list. Each suggestion item is an `<li>` element with appropriate classes
* and data attributes, and an event listener for the click event to handle address selection.
* If there are no suggestions, it toggles the visibility to show a "no results" message.
*
* @param {Array<Object>} suggestions - An array of suggestion objects, each containing a `placeId` and `description`.
* @param {string} suggestions[].placeId - The unique identifier for the suggestion place.
* @param {string} suggestions[].description - The description text for the suggestion.
*/
function renderSuggestionItems(suggestions) {
    $suggestionsList.find(".suggestion-option").remove();

    if (suggestions.length) {
        $.each(suggestions, function(index, suggestion) {
            const $suggestionItem = $(`
                <li class="suggestion-item suggestion-option d-none" data-place-id="${suggestion.placeId}" tabindex="0" role="button">
                    ${suggestion.description}
                </li>`);

            $suggestionItem.on("click", handleSelectAddress);
            $suggestionsList.append($suggestionItem);
            suggestionsToggleVisibility("suggestion-option");
            $addressLoading.addClass("d-none");
        });
    } else {
        suggestionsToggleVisibility("suggestion-no-results");
        $addressLoading.addClass("d-none");
    }
}

/**
* Handles the search address event, fetching address predictions and updating the UI accordingly.
*
* @async
* @param {Event} event - The event object triggered by the user interaction.
* @returns {void}
*/
async function handleSearchAddress(event) {
    const eventType = event.type;

    if (eventType === "click" && !$suggestionsContainer.hasClass("d-none")) {
        return;
    } else if (eventType === "keyup") {
        $addressSave.addClass("disabled");
    }

    const $this = $(this);
    const addressToSearch = $this.val().trim();

    $addressBlock.removeClass("address-error");

    if (addressToSearch.length === 1) {
        suggestionsToggleVisibility("suggestion-no-results");
    } else if (addressToSearch.length > 1) {
        suggestionsToggleVisibility("suggestion-loading");
        $addressLoading.removeClass("d-none");
        renderSuggestionItems(await getPredictions(addressToSearch));
    } else {
        toggleSuggestionsVisibility(false);
    }
}

/**
* Handles the cancellation of the address input process.
*
* This function retrieves the stored address from the session storage and toggles the visibility
* of different UI components based on whether an address is present or not.
*/
function handleAddressCancel() {
    const address = sessionStorage.getItem("liquid_address");

    toggleAddressBlockVisibility(false);

    if (address) {
        toggleAttributesContainerVisibility(true);
    } else {
        toggleAvailabilityBlockVisibility(true);
    }
}

/**
* Checks if a given item matches the specified variant ID and engraving options.
*
* @param {Object} item - The item to be checked, which includes product details and item options.
* @param {string} variantId - The ID of the product variant to match against the item's product ID.
* @param {Object} engravingOptions - The engraving options to match against the item's options.
* @returns {boolean} - Returns true if the item matches the variant ID and engraving options, otherwise false.
*/
function isMatchingItem(item, variantId, engravingOptions) {
    const isSameVariantId = item.product.id === variantId;
    const isSameEngravingOptions = engravingOptions && item.itemOptions && item.itemOptions.line1 === engravingOptions.line1 && item.itemOptions.line2 === engravingOptions.line2;

    return isSameVariantId && !engravingOptions || isSameVariantId && isSameEngravingOptions;
}

/**
* Retrieves the product cart identifier from the session storage based on the variant ID and engraving options.
*
* @param {string} variantId - The ID of the product variant.
* @param {Object} engravingOptions - The engraving options associated with the product.
* @returns {Object|null} The matching cart item if found, otherwise null.
*/
function getProductCartIdentifier(variantId, engravingOptions) {
    const cartJSON = sessionStorage.getItem("liquid_cart");

    if (cartJSON) {
        const cart = JSON.parse(cartJSON);

        return cart.cartItems.find(item => isMatchingItem(item, variantId, engravingOptions));
    }

    return null;
}

/**
* Updates the cart counter display based on the number of items in the cart.
*
* @param {number} itemCount - The number of items in the cart.
*/
function updateCartCounter(itemCount) {
    const $cartCounter = $liquidHeaderMiniCart.find(".liquid-cart-counter");
    const $maxCounter = $cartCounter.attr("data-max-counter");

    if (itemCount === 0) {
        $cartCounter.addClass("d-none");
    } else if (itemCount > 0 && itemCount < 100) {
        $cartCounter.text(itemCount);
        $cartCounter.removeClass("d-none");
    } else {
        $cartCounter.text($maxCounter);
        $cartCounter.removeClass("d-none");
    }
}


/**
* Enables or disables the quantity buttons based on the provided flag.
*
* @param {boolean} enable - A flag indicating whether to enable (true) or disable (false) the quantity buttons.
*/
function enableQtyBtn(enable) {
    const $qtyBtn = $(".quantity-decrease, .quantity-increase");

    $qtyBtn.toggleClass("disabled", !enable);
}

/**
* Updates the mini cart UI based on the provided cart data.
*
* @param {Object} cart - The current state of the cart, including items and subtotal.
* @param {jQuery} $cartItemBody - jQuery object representing the cart item body to be updated.
*/
function renderMiniCartUpdate(cart, $cartItemBody) {
    sessionStorage.setItem("liquid_cart", JSON.stringify(cart));

    const $quantityInput = $cartItemBody.find(".quantity-input");
    const identifier = parseInt($cartItemBody.attr("data-identifier"), 10);
    const item = cart.cartItems.find(item => item.identifier === identifier);

    if (item) {
        const $removeItem = $cartItemBody.find(".liquid-trash-icon");
        const $quantityDecreaseIcon = $cartItemBody.find(".liquid-quantity-decrease-icon");

        if (item.quantity === 1) {
            $removeItem.removeClass("d-none");
            $quantityDecreaseIcon.addClass("d-none");
        } else {
            $quantityDecreaseIcon.removeClass("d-none");
            $removeItem.addClass("d-none");
        }

        $quantityInput.attr("value", item.quantity);
    } else {
        const $cartItem = $quantityInput.closest(".cart-item");
        $cartItem.remove();
    }

    if (!$cartItems.children().length) {
        $emptyCartText.removeClass("d-none");
        $cartItems.addClass("d-none");
        toggleCheckoutCTAVisibility(false);
    }

    // calculate the subtotal by identifying individual items and adding them up
    const cartTotal = calculateCartTotal(cart);
    $subtotalPrice.text(formattedPrice(cartTotal));

    updateCartCounter(cart.itemCount);
}

/**
* Handles the change in quantity of an item in the mini cart.
*
* This function updates the quantity of a cart item based on whether the quantity is being increased or decreased.
* It also handles any personalization options associated with the cart item.
*
* @async
* @param {boolean} isIncrease - Indicates whether the quantity is being increased (true) or decreased (false).
* @returns {Promise<void>} - A promise that resolves when the cart update process is complete.
*/
async function handleMiniCartQuantityChange(isIncrease) {
    enableQtyBtn(false);

    const $this = $(this);
    const $cartItemBody = $this.closest(".cart-item-body");
    const $quantityInput = $cartItemBody.find(".quantity-input");
    const $personalizationBlock = $cartItemBody.find(".cart-item-personalization-block");
    const cartId = parseInt($cartItems.attr("data-cart-id"), 10);
    const value = parseInt($quantityInput.attr("value"), 10);
    const identifier = parseInt($cartItemBody.attr("data-identifier"), 10);
    const variantId = parseInt($cartItemBody.attr("data-variant-id"), 10);
    const cartObject = {
        id: cartId,
        cartItems: []
    };

    if (isIncrease) {
        cartObject.cartItems.push({
            variantId,
            quantity: value + 1
        });
    } else {
        if (value === 1) {
            cartObject.cartItems.push({
                identifier,
                quantity: 0
            });
        } else {
            cartObject.cartItems.push({
                variantId,
                quantity: value - 1
            });
        }
    }

    if ($personalizationBlock.length) {
        const optionsJSON = $personalizationBlock.attr("engraving-options");

        if (optionsJSON) {
            const options = JSON.parse(optionsJSON);
            cartObject.cartItems[0].options = options;
        }
    }

    const cart = await updateCart(cartObject);

    if (cart) {
        renderMiniCartUpdate(cart, $cartItemBody);
        enableQtyBtn(true);
    }
}

/**
* Handles the decrease of the mini cart quantity by invoking the quantity change handler.
* This function is called in the context of the mini cart item and decreases the quantity.
*/
function handleMiniCartQuantityDecrease() {
    handleMiniCartQuantityChange.call(this, false);
}

/**
* Handles the increase of the quantity in the mini cart.
* Calls the handleMiniCartQuantityChange function with the increase flag set to true.
*/
function handleMiniCartQuantityIncrease() {
    handleMiniCartQuantityChange.call(this, true);
}

/**
* Renders the items in the shopping cart and updates the cart UI.
*
* @param {Object} cart - The cart object containing cart items and other details.
*/
function renderCartItems(cart) {
    const $cartItemTemplate = $liquidCustomMiniCart.find(".cart-item-template");

    if (cart.cartItems && cart.cartItems.length) {
        $cartItems.empty();

        $.each(cart.cartItems, function(index, item) {
            const $li = $cartItemTemplate.clone(true);
            const $fulfilledBy = $li.find(".subtitle-fulfilled-by");
            const $cartItemImage = $li.find(".cart-item-image");
            const $cartItemName = $li.find(".cart-item-name");
            const $cartItemSize = $li.find(".cart-item-size");
            const $shipTime = $li.find(".cart-item-ship-time");
            const $itemPrice = $li.find(".item-price");
            const $quantityInputValue = $li.find(".quantity-input");
            const $quantityDecreaseIcon = $li.find(".liquid-quantity-decrease-icon");
            const $removeItem = $li.find(".liquid-trash-icon");
            const $quantityDecreaseBtn = $li.find(".quantity-decrease");
            const $quantityIncreaseBtn = $li.find(".quantity-increase");
            const $cartItemBody = $li.find(".cart-item-body");

            $li.removeClass("cart-item-template d-none");
            $fulfilledBy.text(item.retailerName);
            $cartItemImage.attr("src", item.image).attr("alt", item.name);
            $cartItemName.text(item.name);
            $cartItemSize.text(item.size);
            $shipTime.text(item.shortDeliveryExpectation);
            $itemPrice.text(formattedPrice(item.price));
            $cartItemBody.attr("data-identifier", item.identifier).attr("data-variant-id", item.product.id);
            $quantityInputValue.attr("value", item.quantity);

            if (item.quantity === 1) {
                $removeItem.removeClass("d-none");
                $quantityDecreaseIcon.addClass("d-none");
            } else {
                $quantityDecreaseIcon.removeClass("d-none");
                $removeItem.addClass("d-none");
            }

            $quantityDecreaseBtn.on("click", handleMiniCartQuantityDecrease);
            $quantityIncreaseBtn.on("click", handleMiniCartQuantityIncrease);

            if (item.engravingConfigs.active && item.itemOptions) {
                const {line1, line2} = item.itemOptions;
                const $personalizationBlock = $li.find(".cart-item-personalization-block");
                const $personalizationText = $personalizationBlock.find(".personalization-text");

                $personalizationBlock.attr("engraving-options", JSON.stringify(item.itemOptions)).removeClass("d-none");
                $personalizationText.text(`${line1} - ${line2}`);
            }

            $cartItems.append($li);
        });

        updateCartCounter(cart.itemCount);

        // calculate the subtotal by identifying individual items and adding them up
        const cartTotal = calculateCartTotal(cart);
        $subtotalPrice.text(formattedPrice(cartTotal));

        $emptyCartText.addClass("d-none");
        $cartItems.attr("data-cart-id", cart.id).removeClass("d-none");
        toggleCheckoutCTAVisibility(true);
    }
}


/**
* Handles the add to cart action with personalization options.
*
* This function is triggered by an event and adds an item to the cart with specified engraving options.
* It retrieves the quantity input from the DOM and then calls the `handleAddToCart` function with the
* engraving options and the quantity input selector.
*
* @param {Event} e - The event object triggered by the add to cart action.
*/
function handleAddToCartWithPersonalization(e) {
    const $this = $(this);
    const $quantityInputSelector = $this.parent().parent().find(".quantity-input");

    const engravingOptions = {
        line1:  $(".js-personalization-value").text(),
        line2: $(".js-personalization-km").text()
    };

    handleAddToCart.call(this, e, engravingOptions, $quantityInputSelector);
}

/**
* Handles the "Add to Cart" functionality, including updating the cart with the selected quantity and engraving options.
*
* @async
* @param {Event} e - The event object triggered by the "Add to Cart" action.
* @param {Object} engravingOptions - The engraving options selected by the user.
* @param {jQuery} $quantityInputSelector - The jQuery selector for the quantity input element.
* @returns {Promise<void>} A promise that resolves when the cart update process is complete.
*/
async function handleAddToCart(e, engravingOptions, $quantityInputSelector) {
    const $this = $(this);
    const $loading = $this.find(".liquid-loading");
    const $quantityInput = $quantityInputSelector && $quantityInputSelector.length ? $quantityInputSelector : $this.parent().find(".quantity-input");

    $this.addClass("disabled");
    $loading.removeClass("d-none");

    if ($quantityInput.length) {
        const newQuantity = parseInt($quantityInput.attr("value"), 10);
        const variantId = parseInt($sizeContainerWrapper.find(".active").attr("data-variant-id"), 10);
        const cartId = sessionStorage.getItem("liquid_cart_id");
        const cartItem = getProductCartIdentifier(variantId, engravingOptions);
        const quantity = cartItem ? newQuantity + cartItem.quantity : newQuantity;
        const cartObject = {
            cartItems: [{
                variantId,
                quantity
            }]
        };

        if (cartId) {
            cartObject.id = parseInt(cartId, 10);
        }

        if (engravingOptions) {
            cartObject.cartItems[0].options = engravingOptions;
        }

        const cart = await updateCart(cartObject);

        if (cart) {
            $quantityInput.attr("value", 1);
            sessionStorage.setItem("liquid_cart_id", cart.id);
            sessionStorage.setItem("liquid_cart", JSON.stringify(cart));
            renderCartItems(cart);
            toggleMiniCartVisibility(true);
            $this.removeClass("disabled");
            $loading.addClass("d-none");

            // close the popup and reset the form
            $("#liquidPersonalizationModal").modal("hide");
            resetPersonalizationForm();
        }
    }
}

/**
* Handles the checkout process by retrieving address and cart information from session storage,
* constructing a checkout object, and initiating the checkout process.
*
* @async
* @returns {Promise<void>} - A promise that resolves when the checkout process is complete.
*/
async function handleCheckout() {
    const addressJSON = sessionStorage.getItem("liquid_address");
    const cartId = sessionStorage.getItem("liquid_cart_id");
    const $liquidLoading = $checkoutCTA.find(".liquid-loading");
    const address = JSON.parse(addressJSON);
    const { address1, address2, city, state, zipCode } = address;
    const checkoutObject = {
        cartId,
        address: {
            address1,
            address2,
            city,
            state,
            zipCode
        }
    };

    $checkoutCTA.addClass("disabled");
    $liquidLoading.removeClass("d-none");

    const checkoutData = await checkout(checkoutObject);

    if (checkoutData) {
        const url = checkoutData.url;

        if (url) {
            location.href = url;
        }
    }

    $checkoutCTA.removeClass("disabled");
    $liquidLoading.addClass("d-none");
}

/**
* Attaches event handlers to various elements for address and quantity management.
*/
function loadEvents() {
    const $modalBackground = $html.find(".modal-background");
    const $miniCartCTA = $liquidHeaderMiniCart.find(".mini-cart");
    const $continueShoppingCTA = $liquidCustomMiniCart.find(".continue-shopping");
    const $addToCartCTA = $attributesContainer.find(".liquid-add-to-cart");
    const $quantityDecrease = $attributesContainer.find(".quantity-decrease");
    const $quantityIncrease = $attributesContainer.find(".quantity-increase");
    const $editBtn = $attributesContainer.find(".edit");
    const $addressCancel = $customLiquid.find(".address-cancel");

    $address1Input.on("keyup click", handleSearchAddress);
    $addressSave.on("click", handleSaveAddress);
    $editBtn.on("click", handleEditAddress);
    $addressCancel.on("click", handleAddressCancel);
    $addressAvailabilityBlock.on("click", handleDisplayAddress);
    $quantityDecrease.on("click", handleQuantityDecrease);
    $quantityIncrease.on("click", handleQuantityIncrease);
    $body.on("click", handleClickOutsideSuggestions);
    $modalBackground.on("click", handleCloseMiniCart);
    $continueShoppingCTA.on("click", handleCloseMiniCart);
    $miniCartCTA.on("click", handleOpenMiniCart);
    $addToCartCTA.on("click", handleAddToCart);
    $checkoutCTA.on("click", handleCheckout);

    // add personalization to cart
    $customLiquid.find("#personalizationAddToCart").on("click", handleAddToCartWithPersonalization);
}

/**
* Initializes the mini cart by appending the custom mini cart elements to the body and navbar,
* and rendering the cart items if a cart is stored in session storage.
*
* @returns {void}
*/
function initMiniCart() {
    const $navbarHeaderColRight = $body.find(".navbar-header-col-right");
    const cartJSON = sessionStorage.getItem("liquid_cart");

    $body.append($liquidCustomMiniCart);
    $navbarHeaderColRight.append($liquidHeaderMiniCart);
    $liquidCustomMiniCart.removeClass("d-none");
    $liquidHeaderMiniCart.removeClass("d-none");

    if (cartJSON) {
        const cart = JSON.parse(cartJSON);

        renderCartItems(cart);
    }
}

/**
* Initializes the custom liquid functionality by checking for a stored address in session storage.
* If an address is found, it hides the address block and renders the product data for the given address.
*/
function initLiquidCustom() {
    const addressJSON = sessionStorage.getItem("liquid_address");

    initMiniCart();
    loadEvents();

    if (addressJSON) {
        toggleSkeletonLoaderVisibility(true);
        const address = JSON.parse(addressJSON);
        const formattedAddress = address.formattedAddress;

        $address1Input.val(formattedAddress).attr("data-formatted-address", formattedAddress);
        $addressSave.removeClass("disabled");
        toggleAddressBlockVisibility(false);
        renderProductData(formattedAddress);
    } else {
        toggleAvailabilityBlockVisibility(true);
    }
}

export default function () {
    executeWithTryCatch(initLiquidCustom);
}
